import { APP_ENVIRONMENT, environmentLabel, isProduction } from '../config/env';

export const APP_TITLE = 'BackOffice';

// Refine names browser tabs "<Page> | Refine" (or just "Refine"). Swap its
// name for ours and keep the page part. SF-5172: outside production the tab
// starts with "[Stage]" ("[Local]" on a developer's machine).
export const backOfficeDocumentTitle = (
  autoGeneratedTitle: string,
  env: string = APP_ENVIRONMENT,
): string => {
  const title =
    autoGeneratedTitle === 'Refine'
      ? APP_TITLE
      : autoGeneratedTitle.replace(/ \| Refine$/, ` | ${APP_TITLE}`);
  return isProduction(env) ? title : `[${environmentLabel(env)}] ${title}`;
};
